// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1Pwj0","icon":"SortAdornment_icon__1VcAg","up":"SortAdornment_up__9Ud6a","down":"SortAdornment_down__yD0j6","active":"SortAdornment_active__izK9-"};